<template>
  <ul class="icon-block">
    <slot />
  </ul>
</template>

<style lang="scss">
ul.icon-block {
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
  justify-content: space-between;
  list-style-type: none;
  margin: 0 0 3rem;
  padding: 0;
  width: 100%;

  li {
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 1rem;
    justify-items: center;

    .icon {
      align-items: center;
      background-color: white;
      border-radius: 50%;
      display: flex;
      height: 100px;
      justify-content: center;
      width: 100px;

      img {
        width: 60%;
      }

      span {
        color: rgb(var(--color-dark));
        font-size: 6rem;
      }
    }

    h3,
    p {
      font-size: 1.4rem;
      font-weight: 500;
      max-width: 13.6rem;
      text-align: center;
    }
  }
}
</style>
